import React, { useState, useEffect, forwardRef } from 'react';
import styles from './styles.module.scss';
import { useContext } from 'react';
import Loader from '../Loader';
import { AdminContext } from '../../context/AdminContext';
import Api from '../../api';
import Avatar from '../Avatar';

import SingleContact from '../SingleContact';
import Checkbox from '../CheckBox';
import AppFormInput from '../AppFormInput';
import { Form } from 'react-router-dom';
import AppFormTextArea from '../AppFormTextArea';
import EditImage from '../EditImage';
import blanckUser from '../../../../assets/imgs/blank-profile-picture.png';
import Button from '../Button';
import CookieFunction from '../../functions/cookieFunction';

const UpdateProfileModal = forwardRef((props, ref) => {
  const {
    userInfo,
    setUserInfo,
    setOpenCreateGroup,
    userChannelId,
    activeUser,
    setOpenUpdateProfile,
    setTrigger,
  } = useContext(AdminContext);
  const [contacts, setContacts] = useState([]);
  const [groupInfo, setGroupInfo] = useState({
    imageId: userInfo?.imageId ? userInfo?.imageId : '',
    title: userInfo?.channelName,
    description: userInfo?.content,
    imageName: userInfo?.image?.name ? userInfo?.image?.name : '',
    username: userInfo?.username,
  });
  console.log('userinfo', userInfo);
  const [showTitle, setShowTitle] = useState(true);
  const [showErrorTitle, setShowErrorTitle] = useState(false);
  const [showErrorUsername, setShowErrorUsername] = useState(false);
  const [errorContent, setErrorContent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [serverError, setServerError] = useState('');
  const [success, setSuccess] = useState('');

  const sendFunction = () => {
    setServerError();

    if (checkError()) {
    } else {
      editFunction();
    }
  };

  const editFunction = () => {
    Api.userUpdateProfile({
      imageId: groupInfo?.imageId,
      channelName: groupInfo?.title,
      content: groupInfo?.description,
      username: groupInfo?.username,
    })
      .then((res) => {
        // setGroupInfo({
        //   imageId: '',
        //   title: '',
        //   description: '',
        //   username: '',
        //   imageName: '',
        // });

        props?.informLeftUser(res?.data?.response?.messageId);
        props?.updateUser({
          uuid: userChannelId,
          typeId: activeUser?.typeId,
          // roomId: activeUser?.id,
        });
        console.log('22222', res);
        setSuccess(res?.data?.message);
        setTrigger('updateProfile');
        setOpenUpdateProfile(false);
      })
      .catch((err) => {
        setServerError(err?.response?.data?.message);
      });
  };
  const uploadImage = () => {
    Api.uploadGroupImage()
      .then((res) => {})
      .catch((err) => {});
  };
  const submitFormFunction = () => {};
  const changeTitle = (e) => {
    setGroupInfo({ ...groupInfo, title: e.target?.value });
    setShowErrorTitle(false);
    setServerError();
  };
  const changeUsername = (e) => {
    setGroupInfo({ ...groupInfo, username: e.target?.value });
    setShowErrorUsername(false);
    setServerError();
  };
  const handleChange = (type, value) => {
    setGroupInfo({ ...groupInfo, description: value });
    setServerError();
  };
  const checkError = (addedIds) => {
    if (
      groupInfo?.title?.trim()?.length == 0 ||
      groupInfo?.username?.trim()?.length == 0
    ) {
      if (groupInfo?.title?.trim()?.length == 0) {
        setShowErrorTitle(true);
      }
      if (groupInfo?.username?.trim()?.length == 0) {
        setShowErrorUsername(true);
      }
      return true;
    } else {
      return false;
    }
  };
  console.log('groupInfo', groupInfo);
  useEffect(() => {
    if (success?.length != 0) {
      setTimeout(() => {
        setSuccess('');
      }, [3000]);
    }
  }, [success]);
  return (
    <div
      className={` flex flex-col justify-start items-start w-full h-full relative ${styles.container}`}
    >
      {/* <AppSearch
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        // autoFocus={true}
      /> */}
      <EditImage
        content={props?.content}
        groupInfo={groupInfo}
        setGroupInfo={setGroupInfo}
        setError={setServerError}
        personalInfo={true}
      />
      <div className={styles.section}>
        <AppFormInput
          onChange={changeTitle}
          inputStyle={styles.inputStyle}
          showError={showErrorTitle}
          showTitle={showTitle}
          // onBlur={checkMobileNumber}
          title={props?.content?.personalInfoModal?.title}
          error={props?.content?.errorRequired}
          // placeholder={props?.content?.personalInfoModal?.title}
          placeholder={props?.content?.personalInfoModal?.placeholder}
          wrapperStyle={`${styles.wrapper} borderBottom`}
          value={groupInfo?.title}
        />
      </div>
      <div className={styles.section}>
        <AppFormInput
          onChange={changeUsername}
          inputStyle={styles.inputStyle}
          wrapperStyle={`${styles.wrapper} borderBottom`}
          showError={showErrorUsername}
          showTitle={showTitle}
          // onBlur={checkMobileNumber}
          title={props?.content?.personalInfoModal?.username}
          error={props?.content?.errorRequired}
          placeholder={props?.content?.personalInfoModal?.placeholder}

          value={groupInfo?.username}
        />
      </div>
      <div className={styles.section}>
        {/* <AppFormTextArea
          title={props?.content?.personalInfoModal?.description}
          placeholder={props?.content?.personalInfoModal?.description}
          inputTitleClass={styles.class_title_email}
          wraperClassName={styles.parent_input_text_area}
          inputStyle={
            errorContent
              ? styles.text_area_border_yellow
              : `${styles.text_area} ${styles.wrapper}`
          }
          placeholder={props?.content?.personalInfoModal?.placeholder}
          showError={errorContent}
          error={props?.content?.errorRequired}
          onChange={(e) => {
            handleChange('content', e.target.value);
            setErrorContent(false);
          }}
          rows="2"
          value={groupInfo?.description}
        /> */}
        <AppFormInput
          inputStyle={styles.inputStyle}
          showTitle={showTitle}
          // onBlur={checkMobileNumber}

          wrapperStyle={`${styles.wrapper} borderBottom`}
          title={props?.content?.personalInfoModal?.description}
          placeholder={props?.content?.personalInfoModal?.description}
          inputTitleClass={styles.class_title_email}
          // wraperClassName={styles.parent_input_text_area}
          // inputStyle={
          //   errorContent
          //     ? styles.text_area_border_yellow
          //     : `${styles.text_area} ${styles.wrapper}`
          // }
          inputStyle={styles.inputStyle}
          placeholder={props?.content?.personalInfoModal?.placeholder}
          showError={errorContent}
          error={props?.content?.errorRequired}
          onChange={(e) => {
            handleChange('content', e.target.value);
            setErrorContent(false);
          }}
          value={groupInfo?.description}
        />
      </div>

      {serverError?.length != 0 && (
        <p className={` inputError preserveWhiteThemeColor`}>{serverError}</p>
      )}
      {success?.length != 0 && (
        <p className={` mainTextColor preserveWhiteThemeColor`}>{success}</p>
      )}
      <div
        className={`flex flex-row-reverse justify-start items-center w-full h-auto`}
      >
        <Button
          onClick={sendFunction}
          className={`${styles.sendButton} mainBg`}
        >
          {/* {props?.content?.personalInfoModal?.submit} */}
          {props?.buttonText}
        </Button>
      </div>
    </div>
  );
});

export default UpdateProfileModal;
